export default __webpack_public_path__ + "static/media/cc_green.1fd37567.jpg";